const ApiURL = `https://fmw-backend.herokuapp.com`

// `https://fmw-backend.herokuapp.com`
// https://srln-fmw.herokuapp.com

export default ApiURL
